import template from './assetDetailsAdditionalInfo.template.html';

export default {
  template,
  bindings: {
    asset: '<'
  },
  controllerAs: '$ctrl',
controller: class controller {
    constructor($mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isOpen = false;
      ctrl.destroyWatch = null;
      /*
       * Initialize
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.asset = ctrl.asset || {};
        ctrl.hasAdditionalInfo();
        ctrl.destroyWatch = eventService.onAssetDetailsAdditionalInfo(() => {
          ctrl.isOpen = true;
        });
      };

      ctrl.hasAdditionalInfo = () =>
        !_.isEmpty(ctrl.asset?.additionalInfo)
          ? ctrl.asset?.additionalInfo?.hasAdditionalInfo()
          : false;

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (
          changes.asset &&
          changes.asset.currentValue &&
          changes.asset.currentValue.additionalInfo &&
          Object.keys(changes.asset.currentValue.additionalInfo || {}).length &&
          !Object.keys(
            (changes.asset.previousValue && changes.asset.previousValue.additionalInfo) || {}
          ).length
        ) {
          ctrl.initialize();
        }
      };
    }
  }
};
